<div class="card">
  <div class="card-title d-flex justify-content-between align-items-center">
    <div class="d-flex justify-content-between pl-2 pt-2">      
        <button type="button" *ngIf="readyProccess == true" class="btn btn-icon btn-outline-primary mx-2"
          style="margin-left: 12px;" rippleEffect (click)="Back()">
          <span [data-feather]="'arrow-left'"></span>
        </button>
        <div class="pt-1 align-items-left">
          {{ title }}
        </div>          
    </div>    
    <div class="d-flex justify-content-between pl-2 pt-2" *ngIf="readyProccess == true">
      <button [disabled]="!isReadyToProcess" (click)="ProccessCodes()" class="btn btn-warning text-nowrap mr-2" rippleEffect>
        <i data-feather="plus" class="mr-0 mr-sm-1"></i><span class="d-none d-sm-inline-block text-nowrap">Procesar
          codigos</span>
      </button>

    </div>
  </div>
  <div class="card-body">

    <div *ngIf="readyProccess == false">
      <form [formGroup]="scanForms">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <div  class="sub-heading"><b class="text-primary">*</b>Códigos</div>              
                <textarea text id="float-input" #code class="form-control" [ngClass]="{ 'is-invalid': (f.code.errors && (f.code.touched || f.code.dirty)) || existsCode == true }" formControlName="code" cols="64" rows="10"></textarea>
                
              
              
              <!--<input type="textarea" #code autofocus (input)="changeInput($event)" class="form-control"  formControlName="code" aria-describedby="code-input"
                (paste)="onPasteCode($event)" autofocus="" tabindex="1"
                [ngClass]="{ 'is-invalid': (f.code.errors && (f.code.touched || f.code.dirty)) || existsCode == true }" />-->
              <div *ngIf="existsCode == true" class="invalid-feedback">
              <div>{{error}}</div>
              </div> 
              <div *ngIf="f.code.errors && (f.code.touched || f.code.dirty)" class="invalid-feedback">
                <div *ngIf="f.code.errors.required">El código es requerido.</div>
              </div>
              <div *ngIf="f.code.hasError('pattern') && (f.code.touched || f.code.dirty)" class="invalid-feedback">
                <div>Formato incorrecto.</div>
              </div> 
                          
            </div>
          </div>
          <div class="col-md-2 d-flex justify-content-center align-items-start">
            <button type="button" [disabled]="scanForms.invalid" (click)="addCode()" class="btn btn-primary mt-2" rippleEffect>
              Adicionar Código
            </button>
          </div>
          <div class="col-md-2 d-flex justify-content-center align-items-start">
            <button type="button" class="btn btn-primary mt-2" (click)="CheckCodes()" rippleEffect
              [disabled]="codeList?.length === 0">
              Chequear Códigos
            </button>
          </div>
        </div>
      </form>
      <div class="row pt-2">
        <div class="col-6">
          <div class="d-flex justify-content-between align-items-center">
            <h4>Listado de códigos a procesar </h4>
            <h4>Total: {{codeList.length}}</h4>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <ul class="list-group">
            <li class="list-group-item d-flex justify-content-between align-items-center"
              *ngIf="codeList?.length === 0">
              <span>No se han registrado códigos.</span>
            </li>
            <li class="list-group-item d-flex justify-content-between align-items-center"
              *ngFor="let code of allcodes; let i = index">
              <span>{{i + 1}}</span>
              <span>{{code}}</span>
              <div class="">
                <button type="button" ngbTooltip="Eliminar" placement="left" (click)="RemoveCode(code)"
                  class="btn btn-icon btn-outline-danger text-danger cursor-pointer mr-2" rippleEffect>
                  <i class="fa fa-trash-o" aria-hidden="true"></i>
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="d-flex justify-content-between align-items-center p-2" *ngIf="codeList.length > 0">

            <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize" [maxSize]="4"
              [rotate]="true" [boundaryLinks]="true">
            </ngb-pagination>
            <select class="custom-select" style="width: auto" [(ngModel)]="pageSize">
              <option [ngValue]="5">5 ordenes por página</option>
              <option [ngValue]="10">10 ordenes por página</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="pt-1" *ngIf="readyProccess == true">
      <div class="container-fluid">
        <div class="row">
          <div class="row">
            <div class="col-md-6 col-12">
              <div class="d-flex justify-content-between align-items-center m-1">
                <label class="d-flex align-items-center">Mostrando
                  <select class="form-control mx-25" [(ngModel)]="basicSelectedOption">
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="15">15</option>                    
                  </select>
                  códigos</label>
              </div>
            </div>            
          </div>
          <div class="col-md-12 col-12">
            <ngx-datatable #table ngx-resize-watcher [rows]="scannedBills" [rowHeight]="58"
              class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40" [footerHeight]="50"
              [scrollbarH]="true" [limit]="basicSelectedOption" [messages]="{
            emptyMessage: 'No hay información para mostrar',
            totalMessage: 'Total de paquetes'
          }">
              <ngx-datatable-column name="Codigo" prop="billCode">
                <ng-template let-bill="value" ngx-datatable-cell-template>
                  {{ bill }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Envío" prop="shippingCode">
                <ng-template let-shipping="value" ngx-datatable-cell-template>
                  {{ shipping }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Estado actual" prop="currentState">
                <ng-template let-current="value" ngx-datatable-cell-template>
                  {{ current }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Estado siguiente" prop="nextState" [flexGrow]="1">
                <ng-template let-next="value" ngx-datatable-cell-template>
                  {{ next }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Error" prop="error" [flexGrow]="1">
                <ng-template let-error="value" ngx-datatable-cell-template>
                  <div container="body" placement="left" [ngbTooltip]="error">
                    <ng-container *ngIf="error === ''; else rejected">
                      <div class="badge bg-success">
                        Sin errores
                      </div>
                    </ng-container>
                    <ng-template #rejected>
                      <div class="badge bg-danger" role="alert">
                        Con Errores
                      </div>
                    </ng-template>
                  </div>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-footer *ngIf="true">
                <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize"
                  let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset">
                  <div class="d-flex justify-content-between w-100">
                    <div class="col-7 col-lg-7 col-sm-7" style="padding: 5px 10px">
                      <div>Total registros: {{ rowCount }} </div>
                    </div>
                    <div class="col-5 col-lg-5 col-sm-5 align-items-center align-self-end text-right text-nowrap">
                      <datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'"
                        [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'"
                        [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [visiblePagesCount]="currentVisible"
                        [size]="pageSize" [count]="rowCount" [hidden]="!((rowCount / pageSize) > 1)"
                        (change)="table.onFooterPage($event)">
                      </datatable-pager>
                    </div>
                  </div>
                </ng-template>
              </ngx-datatable-footer>
            </ngx-datatable>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>